// src/features/fiscalization/format.ts
// Shared formatting helpers for fiscalization pages/components.
// Labels are kept jurisdiction-agnostic: "tax authority", "fiscal point",
// "fiscal drive" — never assume a specific country's fiscal regime.

export function formatMoney(money: any): string {
  if (!money) return '--';
  const amount = (money.amount ?? 0) / Math.pow(10, money.decimal_places ?? 2);
  const currency = humanizeEnum(money.currency, 'CURRENCY_');
  const formatted = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return currency ? `${formatted} ${currency}` : formatted;
}

export function formatDate(dateStr: string | undefined | null): string {
  if (!dateStr) return '--';
  try {
    return new Date(dateStr).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return String(dateStr);
  }
}

export function formatDateTime(dateStr: string | undefined | null): string {
  if (!dateStr) return '--';
  try {
    return new Date(dateStr).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch {
    return String(dateStr);
  }
}

/** Turns 'FISCAL_RECEIPT_STATUS_DELIVERY_FAILED' into 'Delivery Failed'. */
export function humanizeEnum(value: string | undefined | null, stripPrefix?: string): string {
  if (!value) return '';
  let v = value;
  if (stripPrefix && v.startsWith(stripPrefix)) v = v.slice(stripPrefix.length);
  if (v === 'UNSPECIFIED') return '';
  return v
    .toLowerCase()
    .split('_')
    .map((w) => (w.length ? w[0].toUpperCase() + w.slice(1) : w))
    .join(' ');
}

export function errMessage(e: unknown, fallback: string): string {
  const anyErr = e as any;
  return anyErr?.message || anyErr?.error?.message || fallback;
}
